import React from 'react';
import ContentLoader from 'react-content-loader';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const rows = [
  { id: 'recipient', label: 'Destinataire' },
  { id: 'status', label: 'État de la commande' },
  { id: 'adress', label: 'Adresse' }
];

/**
 * Entête du tableau dans la section colis prêt
 * @param {Boolean}  loading                         Indique si les requêtes sont terminer
 * @param {Array}    notSentCommandsIds              Liste de tous les ids de commandes non envoyé
 * @param {Array}    checkedCommandsIds              Liste de tous les ids de commandes sélectionné
 */
const EnhancedTableHead = ({ loading }) => (
  <TableHead>
    <TableRow>
      {loading ? (
        <TableCell padding="checkbox">
          <div style={{ width: 24, height: 24, marginLeft: 12 }}>
            <ContentLoader
              height={50}
              width={50}
              speed={2}
              backgroundColor="#f3f3f3"
              foregroundColor="#ecebeb"
            >
              <rect x="109" y="101" rx="0" ry="0" width="0" height="0" />
              <rect x="80" y="58" rx="0" ry="0" width="0" height="0" />
              <rect x="80" y="58" rx="0" ry="0" width="0" height="0" />
              <rect x="0" y="-1" rx="0" ry="0" width="103" height="60" />
              <rect x="36" y="35" rx="0" ry="0" width="0" height="0" />
            </ContentLoader>
          </div>
        </TableCell>
      ) : (
        <TableCell padding="checkbox" />
      )}
      {rows.map(
        row => (
          <TableCell key={row.id} align="left">
            {row.label}
          </TableCell>
        ),
        this
      )}
    </TableRow>
  </TableHead>
);

const mapStateToProps = state => ({
  notSentCommandsIds: state.commands.notSentCommandsIds
});

EnhancedTableHead.propTypes = {
  loading: PropTypes.bool
};

export default connect(mapStateToProps)(EnhancedTableHead);
